import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const SpinnerWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
`;

const SpinnerSvg = styled.svg`
    animation: ${rotate} 1s linear infinite;
    transform-origin: center;
`;

function LoadingSpinner() {
    return (
        <SpinnerWrapper>
            <SpinnerSvg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_2810_11478)">
                    <path
                        d="M24 2C28.3512 2 32.6047 3.29028 36.2225 5.70767C39.8404 8.12506 42.6602 11.561 44.3253 15.581C45.9905 19.6009 46.4262 24.0244 45.5773 28.292C44.7284 32.5596 42.6331 36.4796 39.5563 39.5563C36.4796 42.6331 32.5596 44.7284 28.292 45.5773C24.0244 46.4262 19.6009 45.9905 15.581 44.3253C11.561 42.6602 8.12506 39.8404 5.70767 36.2225C3.29028 32.6047 2 28.3512 2 24"
                        stroke="#ED2E69"
                        strokeWidth="4"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_2810_11478">
                        <rect width="48" height="48" fill="white" />
                    </clipPath>
                </defs>
            </SpinnerSvg>
        </SpinnerWrapper>
    );
}

export default LoadingSpinner;
